import { Component, Input } from '@angular/core';
import { AbstractValueAccessor, MakeProvider } from '../../web-components/abstract-value-accessor';
import { QuestionType } from "../../enums";
import { PreInterviewQuestion } from "../../../typings";

@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    providers: [MakeProvider(QuestionComponent)],
    standalone: false
})
export class QuestionComponent extends AbstractValueAccessor {
  @Input() question: PreInterviewQuestion;
  @Input() pageState: string;

  onKey(event: any) {
    this.question.description = event.target.value;
  }

  propagateText($event: any): void {
    this.onChange($event.target.value);
  }

  public get QuestionType() {
    return QuestionType;
  }
}
